type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const HistorianHeader: Header[] = [

  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "10%", minWidth: "240px" },
    sortable: true,
  },
  {
    key: "patientPhoneNumber",
    label: "Patient Ph No",
    style: { width: "7%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "qmeDoctorName",
    label: "QME Doctor",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "scheduledDate",
    label: "Scheduled Date",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "assignedUserName",
    label: "HX Assigned",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "appointmentDatetime",
    label: "Appointment Date and Time",
    style: { width: "10%", minWidth: "250px" },
    sortable: true,
  },
  {
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "10%", minWidth: "250px" },
    sortable: true,
  },
  {
    key: "locationofAppointment",
    label: "Location",
    style: { width: "250px" },
    sortable: true,
  },
  {
    key: "historianStatusDesc",
    label: "Hx Status",
    style: { width: "20%", minWidth: "350px" },
    sortable: true,
  },
  {
    key: "dateAssigned",
    label: "Date Assigned",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "historyDueDateDesc",
    label: "Due Date",
    style: { width: "8%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "10%", minWidth: "170px" },
    sortable: true,
  },
  // {
  //   key: "tatDays",
  //   label: "Elapsed Days",
  //   style: { width: "5%", minWidth: "150px" },
  //   sortable: true,
  // },
];
